/** Clé de commune : sans accents, majuscules, tirets -> espaces, espaces réduits, ST/STE -> SAINT/SAINTE en préfixe. */
export function cleCommune(brut) {
    if (brut == null) return null;
    const cle = String(brut)
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .toUpperCase()
        .replace(/-/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/^ST /, 'SAINT ')
        .replace(/^STE /, 'SAINTE ');
    return cle === '' ? null : cle;
}
